import { Injectable } from '@angular/core';

export const MANAGER_PREVIEW_MARK = '#manager-preview';

const TOKEN = 'jwtToken';
const PREVIEW_TOKEN = 'managerPreviewToken';
const PREVIEW_EMAIL = 'managerPreviewEmail';
const ADMIN_TOKEN_BACKUP = 'adminTokenBackup';
const IMPERSONATION_KEYS = [ADMIN_TOKEN_BACKUP, 'impersonateActive', 'impersonateManagerEmail'];

export function managerPreviewEmail(): string | null {
  return window.localStorage.getItem(PREVIEW_EMAIL);
}

export function managerPreviewToken(): string | null {
  return window.localStorage.getItem(PREVIEW_TOKEN);
}

export function startManagerPreview(token: string, email: string): void {
  window.localStorage.setItem(PREVIEW_TOKEN, token);
  window.localStorage.setItem(PREVIEW_EMAIL, email);
}

export function endManagerPreview(): void {
  window.localStorage.removeItem(PREVIEW_TOKEN);
  window.localStorage.removeItem(PREVIEW_EMAIL);
}

export function adoptManagerPreview(): void {
  if (window.location.hash !== MANAGER_PREVIEW_MARK) {
    return;
  }
  const token = managerPreviewToken();
  if (token !== null) {
    window.sessionStorage.setItem(TOKEN, token);
  }
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}

export function isManagerPreviewTab(): boolean {
  return window.sessionStorage.getItem(TOKEN) !== null;
}

export function sessionToken(): string {
  const tabToken = window.sessionStorage.getItem(TOKEN);
  if (tabToken === null) {
    return window.localStorage[TOKEN];
  }
  return managerPreviewToken() === null ? '' : tabToken;
}

export function restoreAdminSession(): void {
  const adminToken = window.localStorage.getItem(ADMIN_TOKEN_BACKUP);
  if (adminToken) {
    window.localStorage.setItem(TOKEN, adminToken);
  }
  IMPERSONATION_KEYS.forEach(key => window.localStorage.removeItem(key));
}

@Injectable()
export class JwtService {

  getToken(): string {
    return sessionToken();
  }

  saveToken(token: string) {
    const storage = window.sessionStorage.getItem(TOKEN) === null ? window.localStorage : window.sessionStorage;
    storage.setItem(TOKEN, token);
  }

  destroyToken() {
    const tabToken = window.sessionStorage.getItem(TOKEN);
    if (tabToken === null) {
      window.localStorage.removeItem(TOKEN);
      endManagerPreview();
      IMPERSONATION_KEYS.forEach(key => window.localStorage.removeItem(key));
    } else {
      window.sessionStorage.removeItem(TOKEN);
      if (tabToken === managerPreviewToken()) {
        endManagerPreview();
      }
    }
  }

}
